export enum UserModalMode {
  Add = "Add",
  Edit = "Edit",
}
